var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Sizes } from '../..';
import { ContainerWidths } from '../container';
export var SliderThemes;
(function (SliderThemes) {
    SliderThemes["Light"] = "LIGHT";
    SliderThemes["Dark"] = "DARK";
})(SliderThemes || (SliderThemes = {}));
export var SliderNavigationPositions;
(function (SliderNavigationPositions) {
    SliderNavigationPositions["Top"] = "TOP";
    SliderNavigationPositions["Mid"] = "MID";
})(SliderNavigationPositions || (SliderNavigationPositions = {}));
export var SliderNavigationButtons;
(function (SliderNavigationButtons) {
    SliderNavigationButtons["Transparent"] = "TRANSPARENT";
})(SliderNavigationButtons || (SliderNavigationButtons = {}));
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var SliderWidths = __assign({}, ContainerWidths);
var SliderSpecificPaddings;
(function (SliderSpecificPaddings) {
    SliderSpecificPaddings["None"] = "NONE";
})(SliderSpecificPaddings || (SliderSpecificPaddings = {}));
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var SliderPaddings = __assign(__assign({}, Sizes), SliderSpecificPaddings);
export var SliderSpecificSlidesPerViewProps;
(function (SliderSpecificSlidesPerViewProps) {
    SliderSpecificSlidesPerViewProps["Auto"] = "auto";
})(SliderSpecificSlidesPerViewProps || (SliderSpecificSlidesPerViewProps = {}));
